import { useState } from "react";
import Tabs from "../../../../../../../library/tabs";
import { AVAILABLE_FILTERS } from "../../../context/utils/filters";
import { useSettings } from "../../../context";
import FilterControl from "./control";
import { ConfigurationContentWrapper } from "../../styled";

const VideoSettings = () => {
  const [activeTab, setActiveTab] = useState<string>("hue-rotate");
  const { getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (currentSettings?.type !== "video") {
    return null;
  }

  const renderSelections = () => {
    const appliedFilters = currentSettings.configuration.filters;

    return AVAILABLE_FILTERS.map((filterConfig, index) => {
      const appliedFilter = appliedFilters.find(
        (f) => f.type === filterConfig.value
      );
      const currentValue = appliedFilter
        ? appliedFilter.value
        : filterConfig.defaultValue;

      return {
        id: index,
        key: filterConfig.value,
        title: filterConfig.title,
        display: (
          <ConfigurationContentWrapper>
            <FilterControl config={filterConfig} currentValue={currentValue} />
          </ConfigurationContentWrapper>
        ),
      };
    });
  };

  return (
    <Tabs
      selections={renderSelections()}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};

export default VideoSettings;
